export const update = (target = {}, source = {}): any => {
  return Object.assign(target, source);
};
